<template>
  <div class="px-6 py-8">
    <v-row>
      <v-col>
        <h4 class="fs-18 text-capitalize">
          {{ formattedSummarySectionTitle }}
        </h4>
      </v-col>
      <v-col class="text-right">
        <a
          href="#"
          class="fs-14"
          @click.prevent="onGoToForm"
        >
          <v-icon
            small
            class="mr-1"
            color="primary"
          >
            mdi-pencil
          </v-icon>
          Edit these details
        </a>
      </v-col>
    </v-row>
    <div
      v-if="hasMultiBlock"
      class="px-4 py-6 list-wrap"
    >
      <div
        v-for="(child, childName) in list"
        :key="`${childName}-wrapper`"
        class="child-details"
      >
        <v-row :key="childName">
          <v-col>
            <h4 class="fs-18 text-capitalize">
              {{ childName }}
            </h4>
          </v-col>
        </v-row>
        <template v-for="(value, key) in child">
          <v-row
            v-if="value"
            :key="`${childName}_${key}`"
          >
            <v-col class="fs-14">
              {{ unescape(key) }}
            </v-col>
            <v-col class="font-weight-medium fs-14 wrap-words">
              <template
                v-if="Array.isArray(value)"
              >
                <p
                  v-for="(elem, index) in value"
                  :key="`${childName}_${index}`"
                  class="mb-0"
                >
                  <span v-html="elem" />
                </p>
              </template>
              <template
                v-else-if="typeof value === 'object'"
              >
                <p
                  v-for="(elem, index) in value"
                  :key="`${childName}_${index}`"
                >
                  <strong class="text-capitalize mr-2">
                    <span v-html="index" />
                  </strong>
                  <span v-html="elem" />
                  <v-divider :key="`${childName}-${elem}-${key}`" />
                </p>
              </template>
              <template v-else>
                <span v-html="value" />
              </template>
            </v-col>
          </v-row>
          <v-divider :key="`d-${childName}-${key}`" />
        </template>
      </div>
    </div>
    <div
      v-else
      class="px-4 py-6 list-wrap"
    >
      <template v-for="(value, key) in flatList">
        <v-row
          v-if="value"
          :key="key"
        >
          <v-col class="fs-14">
            {{ unescape(key) }}
          </v-col>
          <v-col class="font-weight-medium fs-14 wrap-words">
            <template
              v-if="Array.isArray(value)"
            >
              <p
                v-for="(elem, index) in value"
                :key="index"
                class="mb-0"
              >
                <span v-html="elem" />
              </p>
            </template>
            <template
              v-else-if="typeof value === 'object'"
            >
              <p
                v-for="(elem, index) in value"
                :key="index"
              >
                <strong class="text-capitalize mr-2">
                  <span v-html="index" />
                </strong>
                <span v-html="elem" />
                <v-divider :key="`${elem}-${key}`" />
              </p>
            </template>
            <template v-else>
              <span v-html="value" />
            </template>
          </v-col>
        </v-row>
        <v-divider :key="`d-${key}`" />
      </template>
    </div>
  </div>
</template>

<script>
import { unescape } from 'lodash';
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'details-list',
  props: {
    list: {
      type: Object,
      required: true,
    },
    summarySectionTitle: {
      type: String,
      required: true,
    },
    formStepLabels: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getStepNumber () {
      return this.formStepLabels[this.formattedSummarySectionTitle];
    },
    formattedSummarySectionTitle () {
      const keys = Object.keys(this.list);
      if (keys.length === 1 && this.hasChildren) {
        return unescape(keys[0]);
      }
      return unescape(this.summarySectionTitle);
    },
    hasChildren () {
      return this.isAllChildrenAreObjects(this.list);
    },
    hasMultiBlock () {
      return Object.keys(this.list).length > 1 && this.hasChildren;
    },
    flatList () {
      const keys = Object.keys(this.list);
      if (keys.length === 1 && this.hasChildren) {
        return this.list[keys[0]];
      }

      return this.list;
    },
  },
  methods: {
    unescape,
    onGoToForm () {
      this.internalTrackerResultsPage(`editTheseDetailsStep${this.getStepNumber}`, true);
      this.$emit('go-to-form', this.getStepNumber);
    },
    isAllChildrenAreObjects (summary) {
      const summaryArray = Object.entries(summary);
      const objectSummaries = summaryArray.filter((item) => (typeof item[1] === 'object' && !Array.isArray(item[1])));
      return objectSummaries.length === summaryArray.length;
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>

<style lang="scss" scoped>
.list-wrap {
  background-color: #fff;
  border: 1px solid $clr-heather;
}

.child-details + .child-details {
  margin-top: 30px;
}
</style>
